import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError, Subject, BehaviorSubject } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { error } from '@angular/compiler/src/util';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  public baseUrl = "https://9h6bwbaajf.execute-api.ap-south-1.amazonaws.com/dev/";
  // public baseUrl = "http://192.168.1.104:2528/";
  public userId: any;
  details: any;
  public loggedIn
  //  local = "http://192.168.1.104:2528/";
  // local = "http://192.168.1.104:2528/";
   fileNum = new BehaviorSubject<string>(''); 
  constructor(private httpClient: HttpClient,
    public router:Router) {
  }

  public loginFunction(data) {
    // const params = new HttpParams()
    //   .set('email', data.email)
    //   .set('password', data.password);
    return this.httpClient.post(this.baseUrl + "login", data);
  };

  public signUp(data) {
    return this.httpClient.post(this.baseUrl + "sign", data);
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };

  public logout() {
    let allData = localStorage.getItem('data');
    this.userId = JSON.parse(allData);
    return this.httpClient.get(this.baseUrl + "logout/" + this.userId.user_id)
  }
  public changePwd(data) {
    return this.httpClient.post(this.baseUrl + "reset_password", data)
  }
  public forgotPassword(data) {
    return this.httpClient.post(this.baseUrl + "forgotPassword" + "/" , data);
  }
  public forgot(data) {
    return this.httpClient.post(this.baseUrl + "forgot_password_save", data);
  }
  public file(data) {
    return this.httpClient.post(this.baseUrl + "fileUpload", data);
  }
  public years(data: { user_id: any; year: any; }) {
    return this.httpClient.get(this.baseUrl + "upload_list/" + data.user_id + "/" + data.year)
  }
  public getYears() {
    return this.httpClient.get(this.baseUrl + "get_years");
  }
  public refer(data) {
    return this.httpClient.post(this.baseUrl + "referFriend", data);
  }
  public otpExpired(data) {
    return this.httpClient.post(this.baseUrl + "forgotPswd_otp_expire", data);
  }

  // @@@@@@@@@@@@

  // File Type in Upload Documents

  public type() {
    return this.httpClient.get(this.baseUrl + "category_File_Type");
  }

  // @@@@@@@@@@@@@@@@@@@

  // Website Footer connect with us

  public connect(data) {
    return this.httpClient.post(this.baseUrl + "connect_with_us", data);
  }

  // @@@@@@@@@@@@@@@@

  // citizen Dashboard Download Tax Return

  public downloadTaxReturn(data) {
    return this.httpClient.get(this.baseUrl + "download_list/" + `${data.user_id}`);
  }

  public manageCategory() {
    return this.httpClient.get(this.baseUrl + 'category_File_Type');
  }

  public updateStatus(data) {
    return this.httpClient.put(this.baseUrl + 'category_File_Action', data);
  }

  public allClients() {
    return this.httpClient.get(this.baseUrl + 'all_clients');
  }

  public updateClientStatus(data) {
    return this.httpClient.put(this.baseUrl + 'manage_clients_ByAdmin', data);
  }

  public allAdmins() {
    return this.httpClient.get(this.baseUrl + 'all_admins');
  }

  public zoneAdminStatus(data) {
    return this.httpClient.put(this.baseUrl + 'zoneadmin_status_modf', data);
  }

  public zoneAdminDelete(data) {
    return this.httpClient.post(this.baseUrl + 'zoneadmin_delete', data);
  }

  public updateZoneAdmin(data) {
    return this.httpClient.post(this.baseUrl +`zoneadmin_update`,data)
  }

  public allLeads(data) {
    return this.httpClient.get(this.baseUrl +`all_Leads/${data}`)
  }
  
  public leadslist() {
    return this.httpClient.get(this.baseUrl +`allAdmins_dropdown`)
  }

  public leadsStatus() {
    return this.httpClient.get(this.baseUrl +`get_leads_status`)
  }

  public leadsAssignTo(data) {
    return this.httpClient.put(this.baseUrl +`leads_Assigend_To`, data)
  }

  public changeLeadStatus(data) {
    return this.httpClient.put(this.baseUrl +`change_lead_status`, data)
    // return this.httpClient.put(this.baseUrl +`change_lead_status`, data)
  }

  public manageReturnTax() {
    return this.httpClient.get(this.baseUrl + `users_retax_History`)
  }

  public pdfService(usr_id, file_nm : any) {
    return this.httpClient.get(this.baseUrl + `retax_fileDownload/${usr_id}/${file_nm}`, {responseType: 'blob'});
  }

  // Register --> Otp Verify 
  public otpSend(data)
  {
    return this.httpClient.post(this.baseUrl+"usr_reg_otp/",data);
  }
}
